import React from "react";

import "./DialogPopupCustomInstructions.css";

function DialopPopupCustomInstructions({ setRegenerateDialogContent, regenerateDialogContent }) {
  return (
    <div className="dialog-popup-custom-instructions-section">
      <label className="dialog-popup-custom-instructions-label">
        <span className="dialog-popup-custom-instructions-title">Custom Instructions</span>
        <span className="dialog-popup-custom-instructions-description">Describe specific changes or improvements</span>
      </label>
      <div className="dialog-popup-custom-instructions-textarea-container">
        <textarea
          onChange={(e) =>
            setRegenerateDialogContent((prev) => ({
              ...prev,
              freeform: e.target.value,
            }))
          }
          value={regenerateDialogContent.freeform}
          placeholder="Describe any changes you'd like to make to this section..."
          className="dialog-popup-custom-instructions-textarea"
          rows={4}
        />
        <div className="dialog-popup-custom-instructions-textarea-counter">
          {regenerateDialogContent.freeform.length}/500
        </div>
      </div>
    </div>
  );
}

export default DialopPopupCustomInstructions;
